var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template-maker" }, [
    !_vm.preview
      ? _c("div", { staticClass: "tools-zone" }, [
          _c(
            "div",
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("dash.template.title")) + ":\n      "
              ),
              _c("div", { staticClass: "custom_link" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.title,
                      expression: "title",
                    },
                  ],
                  attrs: { type: "text", placeholder: "Test de titre" },
                  domProps: { value: _vm.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.title = $event.target.value
                    },
                  },
                }),
              ]),
              _vm.typePost == "image"
                ? _c(
                    "vs-select",
                    {
                      attrs: {
                        label: _vm.$t("dash.template.image.content_text"),
                      },
                      model: {
                        value: _vm.textProperties.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.textProperties, "content", $$v)
                        },
                        expression: "textProperties.content",
                      },
                    },
                    [
                      _c("vs-select-item", {
                        attrs: {
                          value: "title",
                          text: _vm.$t(
                            "dash.template.image.content_text.title"
                          ),
                        },
                      }),
                      _c("vs-select-item", {
                        attrs: {
                          value: "description",
                          text: _vm.$t(
                            "dash.template.image.content_text.description"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.typePost == "image"
                ? _c(
                    "vs-select",
                    {
                      attrs: {
                        label: _vm.$t(
                          "dash.template.image.content_text_style_important"
                        ),
                      },
                      model: {
                        value: _vm.textProperties.style_important,
                        callback: function ($$v) {
                          _vm.$set(_vm.textProperties, "style_important", $$v)
                        },
                        expression: "textProperties.style_important",
                      },
                    },
                    [
                      _c("vs-select-item", {
                        attrs: {
                          value: "enabled",
                          text: _vm.$t(
                            "dash.template.image.content_text_style_important.enabled"
                          ),
                        },
                      }),
                      _c("vs-select-item", {
                        attrs: {
                          value: "disabled",
                          text: _vm.$t(
                            "dash.template.image.content_text_style_important.disabled"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.typePost == "image" &&
              _vm.textProperties.style_important == "enabled"
                ? _c(
                    "div",
                    { staticStyle: { display: "flex", alignItems: "center" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "dash.template.image.content_text_style_important.background_color"
                            )
                          ) +
                          " \n          "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.textProperties
                                .style_important_backgroundColor,
                            expression:
                              "textProperties.style_important_backgroundColor",
                          },
                        ],
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "color" },
                        domProps: {
                          value:
                            _vm.textProperties.style_important_backgroundColor,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.textProperties,
                              "style_important_backgroundColor",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.typePost == "image" &&
              _vm.textProperties.style_important == "enabled"
                ? _c(
                    "div",
                    { staticStyle: { display: "flex", alignItems: "center" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "dash.template.image.content_text_style_important.font_color"
                            )
                          ) +
                          " \n          "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.textProperties.style_important_fontColor,
                            expression:
                              "textProperties.style_important_fontColor",
                          },
                        ],
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "color" },
                        domProps: {
                          value: _vm.textProperties.style_important_fontColor,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.textProperties,
                              "style_important_fontColor",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.typePost !== "image"
                ? _c(
                    "vs-select",
                    {
                      style: {
                        color:
                          _vm.textProperties.color === "#FFFFFF"
                            ? "black"
                            : _vm.textProperties.color,
                      },
                      attrs: {
                        color: _vm.textProperties.color,
                        label: _vm.$t("dash.template.color"),
                      },
                      model: {
                        value: _vm.textProperties.color,
                        callback: function ($$v) {
                          _vm.$set(_vm.textProperties, "color", $$v)
                        },
                        expression: "textProperties.color",
                      },
                    },
                    _vm._l(_vm.possiblesColors, function (item) {
                      return _c("vs-select-item", {
                        key: item.value,
                        attrs: { value: item.hex, text: item.value },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm.typePost !== "image"
                ? _c(
                    "vs-select",
                    {
                      attrs: { label: _vm.$t("dash.template.size") },
                      model: {
                        value: _vm.textProperties.size,
                        callback: function ($$v) {
                          _vm.$set(_vm.textProperties, "size", $$v)
                        },
                        expression: "textProperties.size",
                      },
                    },
                    _vm._l(_vm.possiblesSizes, function (item) {
                      return _c("vs-select-item", {
                        key: item,
                        attrs: { value: item, text: item },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "vs-select",
                {
                  attrs: { label: _vm.$t("dash.template.font") },
                  model: {
                    value: _vm.textProperties.font,
                    callback: function ($$v) {
                      _vm.$set(_vm.textProperties, "font", $$v)
                    },
                    expression: "textProperties.font",
                  },
                },
                _vm._l(_vm.possiblesFonts, function (item) {
                  return _c("vs-select-item", {
                    key: item.value,
                    attrs: { value: item.value, text: item.text },
                  })
                }),
                1
              ),
              _vm.typePost !== "image"
                ? _c(
                    "vs-select",
                    {
                      attrs: { label: _vm.$t("dash.template.align") },
                      model: {
                        value: _vm.textProperties.align,
                        callback: function ($$v) {
                          _vm.$set(_vm.textProperties, "align", $$v)
                        },
                        expression: "textProperties.align",
                      },
                    },
                    _vm._l(_vm.possiblesAlign, function (item) {
                      return _c("vs-select-item", {
                        key: item,
                        attrs: { value: item, text: item },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.typePost !== "image"
            ? _c(
                "div",
                { staticStyle: { display: "flex", alignItems: "center" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("dash.template.background")) +
                      " \n        "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.backgroundColor,
                        expression: "backgroundColor",
                      },
                    ],
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "color" },
                    domProps: { value: _vm.backgroundColor },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.backgroundColor = $event.target.value
                      },
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.typePost != "image"
            ? _c("div", { staticClass: "custom_link" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dash.template.custom_link")) +
                    "\n        "
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.custom_cta,
                      expression: "custom_cta",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.custom_cta },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.custom_cta = $event.target.value
                    },
                  },
                }),
              ])
            : _vm._e(),
          _c("div", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("dash.template.layers")) +
                ":\n        "
            ),
            _c("label", { staticClass: "layers-config" }, [
              _c("div", { staticClass: "add-layer" }, [
                _vm._v("Add new layer"),
              ]),
              _c("input", {
                attrs: { type: "file", accept: "image/*" },
                on: {
                  change: function ($event) {
                    return _vm.addNewLayer($event, _vm.index)
                  },
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "layers-preview" },
              _vm._l(_vm.layers, function (layer, i) {
                return _c("div", { key: i, staticClass: "layer-preview" }, [
                  _c(
                    "span",
                    {
                      staticClass: "remove-layer",
                      on: {
                        click: function ($event) {
                          return _vm.removeLayer(i)
                        },
                      },
                    },
                    [_vm._v("x")]
                  ),
                  _c("img", {
                    attrs: { src: layer.reader || layer.url, alt: i },
                  }),
                ])
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "template-zone",
        class: [
          {
            paysage: _vm.typePost == "image" && _vm.formatImage == "paysage",
            f4sur5: _vm.typePost == "image" && _vm.formatImage == "4/5",
          },
        ],
        style: {
          backgroundColor: _vm.backgroundColor,
          marginLeft: _vm.preview && "0px",
        },
        attrs: { id: "template-zone" },
      },
      [
        _vm.typePost == "image"
          ? _c("p", {
              class: `title-news font${_vm.textProperties.font}`,
              style: {
                color: _vm.textProperties.color,
                fontSize: _vm.textProperties.size + "px",
                textAlign: _vm.textProperties.align || "center",
                border: !_vm.preview && "dashed 1px black",
                lineHeight: "26px",
              },
              domProps: { innerHTML: _vm._s(_vm.getTextInImage()) },
            })
          : _c(
              "p",
              {
                class: `title-news font${_vm.textProperties.font}`,
                style: {
                  color: _vm.textProperties.color,
                  fontSize: _vm.textProperties.size + "px",
                  textAlign: _vm.textProperties.align || "center",
                  border: !_vm.preview && "dashed 1px black",
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.title
                      ? _vm.title
                      : _vm.listNews && _vm.listNews.length
                      ? _vm.textProperties.content == "title"
                        ? _vm.listNews[0].title
                        : _vm.listNews[0].description
                      : "Test de titre"
                  )
                ),
              ]
            ),
        _c("img", {
          staticClass: "image-news",
          attrs: {
            src: _vm.image
              ? _vm.image
              : _vm.listNews && _vm.listNews.length
              ? _vm.listNews[0].enclosure
              : require("../../assets/img/template_image.jpg"),
            alt: "IMAGE",
          },
        }),
        _vm._l(_vm.layers, function (layer, i) {
          return _c("img", {
            key: i,
            staticClass: "image-layer",
            attrs: { id: `layer-${i}`, src: layer.reader || layer.url, alt: i },
          })
        }),
        _vm.typePost != "image"
          ? _c(
              "div",
              {
                class: `link-container ${
                  _vm.linkStyle === 1
                    ? "style-color-1"
                    : _vm.linkStyle === 2
                    ? "style-color-2"
                    : _vm.linkStyle === 3
                    ? "style-color-3"
                    : ""
                }`,
                attrs: { id: "link-container" },
              },
              [
                _c("img", {
                  staticClass: "link-img",
                  attrs: {
                    src: require("../../assets/img/icon_instagram_link.svg"),
                    alt: "Link",
                  },
                }),
                _c("p", { staticClass: "link-txt" }, [
                  _vm._v(
                    _vm._s(
                      _vm.custom_cta
                        ? _vm.custom_cta.toUpperCase()
                        : _vm.link
                        ? _vm.link.split("/")[2].toUpperCase()
                        : "LINK.COM"
                    )
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }